import { render, staticRenderFns } from "./studentInfo.vue?vue&type=template&id=c3182800&"
import script from "./studentInfo.vue?vue&type=script&lang=js&"
export * from "./studentInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports